import { render, staticRenderFns } from "./first-login.vue?vue&type=template&id=157d2c63&scoped=true"
import script from "./first-login.vue?vue&type=script&lang=js"
export * from "./first-login.vue?vue&type=script&lang=js"
import style0 from "./first-login.vue?vue&type=style&index=0&id=157d2c63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157d2c63",
  null
  
)

export default component.exports